import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { themeGet } from '@styled-system/theme-get';
import { readableColor } from 'polished';
import { PropsWithChildren } from 'react';

import type { DamAsset } from '../types';

const Section = styled.section<{ background: string }>`
  background-color: ${({ background }) => themeGet(`colors.${background}`)};
  color: ${({ theme, background }) => readableColor(
    theme.colors[background],
    theme.colors.black,
    theme.colors.white,
  )};
  display: flex;
  flex-direction: column;
  padding: 40px 0 44px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 60px 0 60px;
  }
`;

const Graphic = styled(GatsbyImage)`
  margin: 0 auto 40px;
  width: auto;
  max-width: 125px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0 auto 55px;
    width: auto;
    max-width: 156px;
  }
`;

interface SectionGraphicProps {
  background?: string;
  id?: string;
  img?: DamAsset;
}

const SectionGraphic = ({
  background = 'pale-grey',
  children,
  id,
  img,
}: PropsWithChildren<SectionGraphicProps>) => {
  const image = getImage(img?.asset?.localImage ?? null);

  return (
    <Section id={id} background={background}>
      {image && (
        <Graphic image={image} alt={img?.altText ?? ''} objectFit="contain" />
      )}
      {children}
    </Section>
  );
};

export default SectionGraphic;
